module.exports = __webpack_public_path__ + "static/media/products.f2c3c668.png";